import "./BrandNavBar.scss";
import Dropdown from "react-bootstrap/Dropdown";
import Auth from "@aws-amplify/auth";
import { useLocation, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import React, { useMemo, useState } from "react";
import ConfirmModal from "../Modal/ConfirmModal";
import { avatarBg } from "../../../common/helpers";
import { Avatar, Segmented } from "antd";
import { Link } from "react-router-dom";
import BrandLogo from "../../../components/icons/BrandLogo";
import { USER_TYPE_ORGANIZATION, USER_TYPE_PARTNER } from "../../../constants/constants";
export interface NavBarProps {
  userProfile: any;
}

const BrandNavBar: React.FunctionComponent<NavBarProps> = ({ userProfile }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [logoutModal, setLogoutModal] = useState(false);

  const confirmLogOut = (): void => {
    setLogoutModal(true);
  };

  const logout = () => {
    Cookies.remove("userID");
    Cookies.remove("IsActivated");
    Cookies.remove("PartnerID");
    Cookies.remove("PartnerIDV2");
    Cookies.remove("token");
    Auth.signOut().then(() => {
      navigate("/");
    });
    setLogoutModal(false);
  };

  const handlePartnerNavigation = () => {
    navigate(`/partner/${userProfile.partnerv2_id}`)
  };

  const closeModal = () => {
    setLogoutModal(false);
  };

  const onChangeMenu = (tab: string) => {
    const parent = userProfile?.user_type === USER_TYPE_PARTNER ? '/partner-user' : '/brand-user'
    navigate(tab === 'dashboard' ? parent : `${parent}/${tab}`)
  }

  const activeTab = useMemo(() => {
    const [root, parent, child] = location?.pathname?.split("/")
    if (!child) {
      return "dashboard"
    } else {
      return child
    }
  }, [location])

  const menuOptions = useMemo(() => {
    let items: any = []

    if (userProfile) {
      switch (userProfile?.user_type) {
        case USER_TYPE_PARTNER:
          items = [
            {
              label: "Dashboard",
              value: "dashboard"
            },
            {
              label: "Intelligence",
              value: "intelligence"
            },
            {
              label: "Discovery",
              value: "discovery"
            },
            {
              label: "Trades",
              value: "trades"
            },
            {
              label: "My Profile",
              value: "profile"
            },
          ]
          break;

        case USER_TYPE_ORGANIZATION:
          items = [
            {
              label: "Dashboard",
              value: "dashboard"
            },
            {
              label: "Brands",
              value: "brands"
            },
            {
              label: "Intelligence",
              value: "intelligence"
            },
            {
              label: "Discovery",
              value: "discovery"
            },
            {
              label: "Trades",
              value: "trades"
            },
          ]
          break;

        default:
          break;
      }
    }
    return items;

  }, [userProfile])

  return (
    <div className="header-1 justify-between">
      <Link to={""} className="!border-0">
        <BrandLogo />
      </Link>
      <Segmented
        options={menuOptions}
        onChange={(value) => {
          onChangeMenu(value)
        }}
        value={activeTab}
      />
      <div className="actions">
        <Dropdown className="account-dropdown">
          <Dropdown.Toggle id="dropdown-basic">
            <Avatar style={{ backgroundColor: avatarBg(userProfile?.first_name?.charAt(0)), textTransform: "uppercase" }}>{userProfile?.first_name?.charAt(0)}</Avatar>
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item className="basic-info" eventKey="1">
              <div className="flex gap-x-[8px]">
                <Avatar style={{ backgroundColor: avatarBg(userProfile?.first_name?.charAt(0)), textTransform: "uppercase" }}>{userProfile?.first_name?.charAt(0)}</Avatar>
                <div>
                  <div className="font12-medium gray-800 text-capitalize">
                    {userProfile.first_name} {userProfile.last_name}
                  </div>
                  <div className="font10-regular gray-500">
                    {userProfile.email_id}
                  </div>
                </div>
              </div>
            </Dropdown.Item>
            <Dropdown.Item className="usertype" eventKey="2">
              <div className="usertype-wraper">
                <div className="usertype-icon">
                  <img
                    className="font12-regular"
                    src="/svgs/building-small.svg"
                    alt="user-alternate"
                  />
                </div>
                <div>
                  <div className="font12-regular gray-600">
                    {userProfile?.organization?.company_name
                      ? userProfile.organization.company_name
                      : userProfile?.partner?.company_name
                        ? userProfile?.partner?.company_name
                        : "Asia Ecomm Group"}
                  </div>
                  {userProfile.user_roles && (
                    <div
                      key={userProfile.user_roles[0]?.roles?.id}
                      className="font12-regular gray-500"
                    >
                      {userProfile.user_roles[0]?.roles?.role_name}
                    </div>
                  )}
                </div>
              </div>
            </Dropdown.Item>
            {/* {userProfile?.user_type === "partner" && (
              <Dropdown.Item
                className="partner-details"
                eventKey="2"
                onClick={handlePartnerNavigation}
              >
                <div className="usertype-wraper">
                  <div>
                    <div className="font12-regular gray-600">
                      Partner Profile
                    </div>
                  </div>
                </div>
              </Dropdown.Item>
            )} */}
            <Dropdown.Item
              className="font12-regular error-600 logout"
              eventKey="2"
              onClick={confirmLogOut}
            >
              Log Out
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
        <ConfirmModal
          isModalOpen={logoutModal}
          submit={logout}
          closeModal={closeModal}
          submitBtnText="Yes, Log Out"
          cancelBtnText="No"
          title="Confirm Log Out"
          bodyText="Are you sure you want to Log Out ?"
        />
      </div>
    </div>
  );
};

export default BrandNavBar;
